import { Link } from 'react-router';
import {
  TdsHeader,
  TdsHeaderBrandSymbol,
  TdsHeaderTitle,
  TdsHeaderLauncher,
  TdsHeaderLauncherList,
  TdsHeaderLauncherListItem,
  TdsHeaderLauncherListTitle,
} from '@scania/tegel-react';
import { type ReactElement } from 'react';
import { signOut } from '@/services/auth/utils/sign-out';

interface NavbarProperties {
  readonly title: string;
  readonly userFirstName: string;
  readonly userLastName: string;
  readonly isSignedIn: boolean;
  readonly onOpenGuidelines?: () => void;
}

const Navbar = ({
  title,
  userFirstName,
  userLastName,
  isSignedIn,
  onOpenGuidelines,
}: NavbarProperties): ReactElement => (
  <TdsHeader>
    <TdsHeaderTitle>{title}</TdsHeaderTitle>
    {isSignedIn && (
      <TdsHeaderLauncher slot="end">
        <TdsHeaderLauncherListTitle>
          <div>
            {userFirstName} {userLastName} / Scania
          </div>
        </TdsHeaderLauncherListTitle>
        <TdsHeaderLauncherList>
          <TdsHeaderLauncherListItem>
            <button type="button" onClick={onOpenGuidelines}>
              Guidelines
            </button>
          </TdsHeaderLauncherListItem>
          <TdsHeaderLauncherListItem>
            <button
              type="button"
              onClick={() => {
                void signOut();
              }}
            >
              Logout
            </button>
          </TdsHeaderLauncherListItem>
        </TdsHeaderLauncherList>
      </TdsHeaderLauncher>
    )}
    <TdsHeaderBrandSymbol slot="end" data-testid="brand-symbol">
      <Link aria-label="Scania - red gryphon on blue shield" to="/" />
    </TdsHeaderBrandSymbol>
  </TdsHeader>
);

export default Navbar;
